<template>
    <div>
         <v-data-table
            :key="componentKey"
            :headers="computedHeaders"
            :items="tableItems"
            class="elevation-1"
            :loading="childrenShortCardLoadStatus===1"
            hide-default-footer
            disable-pagination
            must-sort
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Kończące się karty</v-toolbar-title>
              </v-toolbar>
            </template>
      
            <template v-slot:item.actions="{ item }">
                <v-btn :to="{name:'slowniki.dziecko',params:{id:item.id,year_id: defaultYear}}" color="primary" x-small>Karta</v-btn>
            </template>
            
          </v-data-table> 
        </div>
</template>

<script>
     
  export default {
    data: () => ({
      componentKey:0,
      headers: [
        { text: '',align: 'start',sortable: false,value: 'lp',filterable:false,display:true},
        { text: 'Imię', value: 'name',filterable:false,filterColumn:"name",display:true },
        { text: 'Nazwisko', value: 'surname',filterable:false,filterColumn:"name",display:true },
        { text: 'Grupa', value: 'course.name',filterable:false,filterColumn:"course_name",display:true },
        { text: 'Termin ważności', value: 'rates_with_short_card.pivot.expiry',filterable:false,filterColumn:"expiry",display:true },
        { text: '', value: 'actions', sortable: false,filterable:false,display:true },
      ],
    }),
    watch: {
   
    },
    computed: {
      user(){
        return this.$store.getters.getUser;
      },
      lookups(){
        return this.$store.getters.getLookups;
      },
      tableItems(){
        return this.$store.getters.getChildrenShortCard;
      },
      childrenShortCardLoadStatus(){
        return this.$store.getters.getCoursesLoadStatus;
      },
      computedHeaders () {
        var localHeaders = [...this.headers.filter(h => h.display===true)]
        return localHeaders
      },
      defaultYear(){
        return _.find(this.lookups.years,{'default':1}).value;
      }
    },
    methods: {
    
    },
  }
</script>
<style scoped>
.search{
      max-width: 250px;
}
.choose_year{
      max-width: 150px;
}
</style>